export enum UserTicketStatusEnum {
    PENDING = "PENDING",
    CHECKEDIN = "CHECKEDIN",
}